// FIXME: These values are from Google Translate. We need the actual translation from Design team.
export var ErrorVerbiage = {
    Retriable: '支払いを処理できませんでした。カード情報を確認して、もう一度お試しください。',
    NonRetriable: '支払いを処理できませんでした。別のお支払い方法を入力して、もう一度お試しください。',
    SystemError: '支払いを処理できませんでした。もう一度試してください。'
};
